if (!customElements.get('cc-product-offers')) {
  customElements.define('cc-product-offers', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.sync = () => {
        const quantity = this.root?.querySelector('input[name="quantity"]');
        if (!quantity) return;
        this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === quantity.value; });
      };
      this.onChange = event => {
        if (this.contains(event.target) && event.target.type === 'radio') {
          const quantity = this.root?.querySelector('input[name="quantity"]');
          if (!quantity) return;
          quantity.value = event.target.value;
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (event.target.name === 'quantity') this.sync();
      };
      this.root?.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(this.sync);
      if (this.root) this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
    }
  });
}
